import React from 'react';
import { FaApple, FaChrome, FaGooglePlay } from 'react-icons/fa';
import { apps, STATUS_LABELS } from '../data/apps';

const AppleIcon = FaApple as React.ElementType;
const GooglePlayIcon = FaGooglePlay as React.ElementType;
const ChromeIcon = FaChrome as React.ElementType;

const StoreBadge: React.FC<{ href: string; icon: React.ReactNode; small: string; main: string }> = ({ href, icon, small, main }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" className="store-badge">
    {icon}
    <span className="store-badge-text">
      <span className="store-badge-small">{small}</span>
      <span className="store-badge-main">{main}</span>
    </span>
  </a>
);

const Apps: React.FC = () => {
  return (
    <section id="apps" className="apps">
      <div className="container">
        <h2 className="section-title">Our Apps</h2>
        <p className="section-subtitle">Apps and browser extensions made by Spiegelei Studio</p>

        <div className="app-grid">
          {apps.map((app) => (
            <div key={app.id} className="app-card">
              <div className="app-icon">
                <img src={app.logo} alt={`${app.title} logo`} className="app-logo" />
              </div>
              <h3 className="app-title">{app.title}</h3>
              <div className="app-meta">
                <span className={`app-status app-status-${app.status}`}>{STATUS_LABELS[app.status]}</span>
                <span className="app-platforms">{app.platforms}</span>
              </div>
              <p className="app-description">{app.description}</p>
              {app.features.length > 0 && (
                <ul className="app-features">
                  {app.features.map((feature) => (
                    <li key={feature}>{feature}</li>
                  ))}
                </ul>
              )}
              {(app.appStoreUrl || app.playStoreUrl || app.chromeStoreUrl) && (
                <div className="app-actions">
                  {app.appStoreUrl && (
                    <StoreBadge href={app.appStoreUrl} icon={<AppleIcon size={24} color="white" />} small="Download on the" main="App Store" />
                  )}
                  {app.playStoreUrl && (
                    <StoreBadge href={app.playStoreUrl} icon={<GooglePlayIcon size={20} color="white" />} small="Get it on" main="Google Play" />
                  )}
                  {app.chromeStoreUrl && (
                    <StoreBadge href={app.chromeStoreUrl} icon={<ChromeIcon size={22} color="white" />} small="Available in the" main="Chrome Web Store" />
                  )}
                </div>
              )}
              {app.websiteUrl && (
                <a href={app.websiteUrl} target="_blank" rel="noopener noreferrer" className="app-website-link">
                  {app.websiteUrl.replace(/^https?:\/\//, '')}
                </a>
              )}
              {app.webBilling && (
                <p className="app-legal-links">
                  <a href={app.webBilling.pricingUrl} target="_blank" rel="noopener noreferrer">Pricing</a>
                  <a href={app.webBilling.termsUrl} target="_blank" rel="noopener noreferrer">Terms</a>
                  <a href={app.webBilling.privacyUrl} target="_blank" rel="noopener noreferrer">Privacy</a>
                  <a href={app.webBilling.refundUrl} target="_blank" rel="noopener noreferrer">Refunds</a>
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Apps;
